module.exports = __webpack_public_path__ + "static/img/poster.206a65f6.jpg";